import * as React from 'react';

const LegalsLinks: React.FC<ILegalsLinksProps> = ({ items }) => (
    <>{items}</>
);

export interface ILegalsLinksProps {
    items: JSX.Element[];
}

export default LegalsLinks;
